const getMostRecentSubscriptionTime = (subscriptions) => {
    return subscriptions.reduce((acc, val) => {
        if (val.created_at > acc) {
            acc = val.created_at;
        }
        return acc;
    }, subscriptions[0].created_at);
};
export const sortFnByScheduleAndCreationTime = (a, b) => {
    if (a.schedule_start === b.schedule_start) {
        const mostRecentSubscriptionTimeA = getMostRecentSubscriptionTime(a.subscriptions);
        const mostRecentSubscriptionTimeB = getMostRecentSubscriptionTime(b.subscriptions);

        if (mostRecentSubscriptionTimeA > mostRecentSubscriptionTimeB) {
            return -1;
        } else {
            return 1;
        }
    } else {
        if (a.schedule_start < b.schedule_start) {
            return -1;
        } else {
            return 1;
        }
    }
};
